import { Button } from "@mui/material";
import default_theme from "assets/themes/themes";

const DangerButton = ({ children, sx = {}, ...props }) => (
  <Button
    variant="outlined"
    sx={{
      backgroundColor: "#fff",
      color: default_theme.palette.other.socialGoogle,
      borderColor: default_theme.palette.other.socialGoogle,
      "&:hover": {
        backgroundColor: default_theme.palette.other.socialGoogle,
        color: "#fff",
        borderColor: default_theme.palette.other.socialGoogle,
      },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Button>
);

export default DangerButton;